<div class="splash-screen" *ngIf="(isLoading$ | async) === true">
	<div class="splash-screen-content">
		<div class="splash-screen-image"></div>
		<div class="splash-screen-dots">
			<span></span>
			<span></span>
			<span></span>
			<span></span>
			<span></span>
		</div>
	</div>
</div>
